module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && _vm.isipx) ? _c('div', {
    staticClass: "wrapper-ipx weex-ct weex-div",
    style: ({
      'background-color': _vm.bgColor || 'transparent',
      'border-top-color': _vm.borderTopColor || 'transparent'
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-002ed91c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002ed91c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-ipx-bar/index.vue
// module id = 560
// module chunks = 0 1